module.exports = __webpack_public_path__ + "static/media/Шаг 3.d83e7902.png";